
const SiteKeyReducer = (state = {siteKey:""}, action) => {
	if(action.type === 'SET_SITE_KEY') {
		var newState = {};
		Object.assign(newState,state);
		newState[action.key] = action.payload;
		return newState;
	}else {
		return state
	}
}

export default SiteKeyReducer